import { Button } from "@mui/material";
import type { FC, MouseEvent, PropsWithChildren } from "react";

interface Props {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const CancelButton: FC<PropsWithChildren<Props>> = ({ onClick, children }) => (
  <Button variant="outlined" color="secondary" onClick={onClick}>
    {children ?? "Anuluj"}
  </Button>
);

export default CancelButton;
